import { toast } from "react-toastify";
import { useEffect } from "react";
import { matchPath } from "react-router-dom";
export function Filter(data, inputValue) {
  return data?.filter((element) =>
    checkState(element, latinNumber(inputValue))
  );
}

function checkState(element, inputValue) {
  const filterValues = inputValue.trim().split(" ");
  const states = [];

  for (let index = 0; index < filterValues.length; index++) {
    states[index] = getState(element, filterValues[index]);
  }

  return states.every((state) => state === true);
}

function getState(data, inputValue, state = false) {
  for (const value of Object.values(data)) {
    if (
      typeof value === "object" &&
      value !== null &&
      Object.keys(value).length > 0 &&
      state === false
    ) {
      state = getState(value, inputValue, state);
    } else {
      if (state === false) {
        state = JSON.stringify(value)
          .toLowerCase()
          .includes(inputValue.toLowerCase());
      } else {
        return state;
      }
    }
  }
  return state;
}

export const getTailwindScreenSize = () => {
  const w = document.body.offsetWidth;

  if (w <= 640) return "sm";
  if (w <= 768) return "md";
  if (w <= 1024) return "lg";
  if (w <= 1280) return "xl";
  if (w <= 1536) return "2xl";

  return "lg";
};

export function shadeColor(color, percent) {
  let R = parseInt(color.substring(1, 3), 16);
  let G = parseInt(color.substring(3, 5), 16);
  let B = parseInt(color.substring(5, 7), 16);

  R = parseInt((R * (100 + percent)) / 100);
  G = parseInt((G * (100 + percent)) / 100);
  B = parseInt((B * (100 + percent)) / 100);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  let RR = R.toString(16).length === 1 ? "0" + R.toString(16) : R.toString(16);
  let GG = G.toString(16).length === 1 ? "0" + G.toString(16) : G.toString(16);
  let BB = B.toString(16).length === 1 ? "0" + B.toString(16) : B.toString(16);

  return "#" + RR + GG + BB;
}

export function toCommas(number, decimals, dec_point, thousands_sep) {
  try {
    number = latinNumber(number);
    let n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
      dec = typeof dec_point === "undefined" ? "." : dec_point,
      toFixedFix = function (n, prec) {
        let k = Math.pow(10, prec);
        return Math.round(n * k) / k;
      },
      s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split(".");
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
  } catch (e) {
    return 0;
  }
}

export function convertToInternationalCurrencySystem(labelValue, hasK = true) {
  if (!labelValue) {
    return "-";
  }
  // Nine Zeroes for Billions
  return Math.abs(Number(labelValue)) >= 1.0e9
    ? toCommas((Math.abs(Number(labelValue)) / 1.0e9).toFixed(3), 3) + " B"
    : // Six Zeroes for Millions
    Math.abs(Number(labelValue)) >= 1.0e6
    ? toCommas((Math.abs(Number(labelValue)) / 1.0e6).toFixed(3), 3) + " M"
    : // Three Zeroes for Thousands
    hasK
    ? Math.abs(Number(labelValue)) >= 1.0e3
      ? toCommas((Math.abs(Number(labelValue)) / 1.0e3).toFixed(3), 3) + " K"
      : Math.abs(Number(labelValue))
    : toCommas(labelValue, 3);
}

export function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}

export default function getRandomColor() {
  let letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

const latinToPersianMap = ["۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹", "۰"];
const latinNumbers = [
  /1/g,
  /2/g,
  /3/g,
  /4/g,
  /5/g,
  /6/g,
  /7/g,
  /8/g,
  /9/g,
  /0/g,
];

const persianToLatinMap = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
const persianNumbers = [
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
  /۰/g,
];

function prepareNumber(input) {
  let string;
  if (typeof input === "number") {
    string = input.toString();
  } else if (typeof input === "undefined") {
    string = "-";
  } else {
    string = input || "";
  }

  return string;
}

export function persianToLatin(string) {
  let result = string || "";

  for (let index = 0; index < 10; index++) {
    result = result.replace(persianNumbers[index], persianToLatinMap[index]);
  }

  return result;
}

export function latinNumber(input) {
  return persianToLatin(prepareNumber(input));
}

function latinToPersian(string) {
  let result = string || "";

  for (let index = 0; index < 10; index++) {
    result = result.replace(latinNumbers[index], latinToPersianMap[index]);
  }

  return result;
}

export function persianNumber(input) {
  return latinToPersian(prepareNumber(input));
}

export const customToast = (type = "error", message = "", options = {}) => {
  toast.dismiss();
  if (type === "error") {
    return toast.error(message, { ...options });
  }
  return toast.success(message, { ...options });
};

export const LEFT_TO_RIGHT_MARK = "\u200e";

export function getFileTypeName(typeId) {
  let o = Object.freeze({
    0: "text",
    1: "audio",
    2: "video",
    3: "image",
    4: "file",
    5: "zip",
  });

  return o[typeId];
}

export function getFileType(file) {
  let o = Object.freeze({
    1: "صوت",
    2: "ویدئو",
    3: "عکس",
    4: "سند",
    5: "فایل فشرده",
  });

  try {
    return o[file];
  } catch {
    return "سند";
  }
}

export function Linkify(inputText) {
  let replacedText, replacePattern1, replacePattern2, replacePattern3;

  replacePattern1 =
    /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = inputText.replace(
    replacePattern1,
    '<a href="$1" target="_blank">$1</a>'
  );

  replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(
    replacePattern2,
    '$1<a href="http://$2" target="_blank">$2</a>'
  );

  replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
  replacedText = replacedText.replace(
    replacePattern3,
    '<a href="mailto:$1">$1</a>'
  );

  return replacedText;
}

export const isPathActive = (path, exact) => {
  return matchPath({ path, exact }, window.location.hash.replace("#", ""));
};

export const supportedFormats = [
  "text/plain",
  "text/csv",
  "text/comma-seperated-values",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

export const typeConventor = (type) => {
  switch (+type) {
    case 0:
      return "آپلود فیش";
    case 1:
      return "ارسال اس ام اس";
    case 2:
      return "مخالفت با تبدیل مطالبات به سهم";
    case 3:
      return "موافقت با برداشت از مطالبات";
    case 4:
      return "پرداخت آنلاین";
    case 5:
      return "در انتظار پرداخت آنلاین";
    case 6:
      return "پرداخت آنلاین";
    case 7:
      return "آپلود فیش بعد از اتمام انقضا";
    case 8:
      return "پرداخت پرتال سهامی";
    case 9:
      return "حذف مخالفت با برداشت از مطالبات";
    case 10:
      return "حذف موافقت با برداشت از مطالبات";
    case 11:
      return "حذف فیش";
    case 12:
      return "حذف فیش بعد از تاریخ انقضا";
    default:
      return "تا این لحظه عملیاتی ثبت نشده است";
  }
};

export function sortByDate(arr) {
  return arr.sort(function (a, b) {
    return new Date(b.CreatedAt).getTime() - new Date(a.CreatedAt).getTime();
  });
}

export function findInsCode(companiesList, persianName) {
  return companiesList?.filter(
    (company) => company?.companyName === persianName
  )?.[0]?.InsCode
}
